import {Controller} from '@hotwired/stimulus';
import axios from "axios";

export default class extends Controller {
    constructor() {
        super();
        this.api = axios.create({
            baseURL: '/wp-json/api/contract-changes/',
        });
    }

    connect() {
        this.initModalElements();
        this.setupListeners();
    }

    initModalElements() {
        this.contractModal = document.getElementById('contractChangeModal');
        this.contractChangeBar = document.getElementById('contractChangeBar');

        if (!this.contractModal) return;

        this.modalAccept = this.contractModal.querySelector('.modal-accept');
        this.modalReplacement = this.contractModal.querySelector('.replace-content');
        this.modalLoader = this.contractModal.querySelector('.contract-loader');

        this.modalController = Stimulus.getControllerForElementAndIdentifier(this.contractModal, 'modal');
    }

    setupListeners() {
        const viewContractButton = document.querySelector('.view-contract-changes');

        if (viewContractButton) {
            viewContractButton.addEventListener('click', this.showContractAcceptModal.bind(this));
        }

        if (this.modalAccept) {
            this.modalAccept.addEventListener('click', this.acceptContract.bind(this));
        }
    }

    async showContractAcceptModal() {
        if (!this.modalController) return;

        this.toggleLoader(true);
        this.modalReplacement.innerHTML = '';
        this.modalController.showModal();

        try {
            let response = await this.api.get('contract');
            response = response.data.data;
            this.toggleLoader(false);
            this.renderContractImages(response);
        } catch (error) {
            this.showError('Error loading contract.');
        }
    }

    renderContractImages(response) {
        if (response.images && response.images.length > 0) {
            this.modalReplacement.innerHTML = response.images.map(image =>
                `<img alt="Contract" src="${image}" width="100%" style="margin-bottom: 20px;">`
            ).join('');
        } else if (response.error) {
            this.modalReplacement.innerHTML = `<p>Error: ${response.error}</p>`;
        }
    }

    async acceptContract() {
        const data = { contractId: 123 };

        try {
            await this.api.post('accept', data);
            this.modalController.hideModal();
            this.contractChangeBar.remove();
        } catch (error) {
            this.showError('Error accepting contract.');
        }
    }

    toggleLoader(show) {
        if (show) {
            this.modalLoader.classList.remove('d-none');
        } else {
            this.modalLoader.classList.add('d-none');
        }
    }

    showError(message) {
        console.error(message);
        this.modalReplacement.innerHTML = `<p>${message}</p>`;
        this.toggleLoader(false);
    }

    disconnect() {
        const viewContractButton = document.querySelector('.view-contract-changes');
        if (viewContractButton) {
            viewContractButton.removeEventListener('click', this.showContractAcceptModal.bind(this));
        }

        if (this.modalAccept) {
            this.modalAccept.removeEventListener('click', this.acceptContract.bind(this));
        }
    }
}